import React from 'react';
import './refund.css'
import Footer from '../../Footer';

function C2wRefundPolicy() {
  return (
    <div className="privacy">
    <h1>Refund Policy</h1>
    <ol>
      <li>
        <p>
          We want you to be satisfied, so all eligible courses purchased on
          the website can be refunded within 10 days after your request.{" "}
        </p>
      </li>

      <li>
        <p>
          Certain restrictions may apply and some purchases may only be
          eligible for credit refunds.
        </p>
      </li>

      <li>
        <p>
          We reserve the right, in our sole discretion, to limit or deny
          refund requests in cases where we believe there is refund abuse,
          including but not limited to the following:
        </p>
        <ul>
          <li>
            A significant portion of the course has been consumed or
            downloaded by a student before the refund was requested.
          </li>
          <li>
            Multiple refunds have been requested by a student for the same
            course.
          </li>
          <li>Excessive refunds have been requested by a student.</li>
          <li>
            Users who have their account reported, banned or course access
            disabled due to a violation of our Terms or Trust & Safety
            Guidelines.{" "}
          </li>
          <li>
            We do not grant refunds for any subscription services unless
            otherwise required by applicable law (please see below for more
            information).{" "}
          </li>
          <li>
            These refund restrictions will be enforced to the extent
            permitted by applicable law.
          </li>
        </ul>
      </li>

      <li>
        <h3>Pricing</h3>
        <ul>
          <li>
            The prices of content on Website are determined based on the
            terms of the Instructor Terms. In some instances, the price of
            content offered on the website may vary around implementing
            sales and promotions from time to time.
          </li>
          <li>
            We occasionally run promotions and sales for our content, during
            which certain content is available at discounted prices for a
            set period of time. The price applicable to the content will be
            the price at the time you complete your purchase of the content
            (at checkout). Any price offered for particular content may also
            be different when you are logged into your account from the
            price available to users who aren’t registered or logged in,
            because some of our promotions are available only to new users.
          </li>
          <li>
            If you are logged into your account, the listed currency you see
            is based on your location when you created your account. If you
            are not logged into your account, the price currency is based on
            the country where you are located. We do not enable users to see
            pricing in other currencies.
          </li>
          <li>
            If you are a student located in a country where use and sales
            tax, goods and services tax, or value added tax is applicable to
            consumer sales, we are responsible for collecting and remitting
            that tax to the proper tax authorities. Depending on your
            location, the price you see may include such taxes, or tax may
            be added at checkout.
          </li>
        </ul>
      </li>

      <li>
        <h3>Payments</h3>
        <ul>
          <li>
            You agree to pay the fees for content that you purchase, and you
            authorize us to charge your debit or credit card or process
            other means of payment (such as third party payment gateways,
            netbanking, or mobile wallet) for those fees. We works with
            payment service providers to offer you the most convenient
            payment methods in your country and to keep your payment
            information secure. We may update your payment methods using
            information provided by our payment service providers. Check out
            our Privacy Policy for more details.
          </li>
          <li>
            When you make a purchase, you agree not to use an invalid or
            unauthorized payment method. If your payment method fails and
            you still get access to the content you are enrolling in, you
            agree to pay us the corresponding fees within ten (10) days of
            notification from us. We reserve the right to disable access to
            any content for which we have not received adequate payment.
          </li>
        </ul>
      </li>

      <li>
        <h3>Refunds</h3>
        <p>
          If the content you purchased is not what you were expecting, you
          can request it within 2 days of your purchase of the content. That
          we apply a refund to your account 10 business days after your
          request. We reserve the right to apply for your refund as a refund
          credit or a refund to your original payment method, at our
          discretion, depending on the capabilities of our payment service
          providers, the platform from which you purchased your content. No
          refund is due to you if you request it after the 10-day guarantee
          time limit has passed. However, if the content you previously
          purchased is disabled for legal or policy reasons, you are
          entitled to a refund beyond this 10-day limit. We also reserve the
          right to refund students beyond the 10-day limit in cases of
          suspected or confirmed account fraud.
        </p>
      </li>
    </ol>
        <div className="ADfooter__container">
          <Footer />
        </div>
  </div>
  )
}

export default C2wRefundPolicy
